import React from 'react'

const Required = () => (<span className="text-danger">*</span>)

export default Required
